import { InjectionToken, inject } from '@angular/core';
import { IEmailStore } from './email.public';
import { EmailStore } from './email.store';

export const EMAIL_STORE = new InjectionToken<IEmailStore>('EMAIL_STORE', {
    providedIn: 'root',
    factory: () => inject(EmailStore) as IEmailStore,
});
